<template>
  <el-dialog ref="dialog" title="配置控件" size="large" style="min-width:1280px">
    <div class="m-b-10">
      <el-button type="primary" size="small" @click="setTempInputType(30)">全部不使用</el-button>
      <el-button type="primary" size="small" @click="setTempInputType(40)">全部不可见</el-button>
      <el-button type="primary" size="small" @click="setTempInputType(10)">全部只读</el-button>
      <el-button type="primary" size="small" @click="setTempInputType(20)">全部可写</el-button>
      <el-select v-model="oldRule" class="w-150 m-l-10 m-r-10">
        <el-option v-for="item in rules" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <span>替换</span>
      <el-select v-model="curRule" class="w-150 m-l-20">
        <el-option v-for="item in rules" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="replaceRule" class="m-l-10">确认</el-button>
    </div>
    <div>
      <div class="f-l p-r-10 m-r-10 bor-r-ccc" style="width:60%">
        <el-table
          ref="inputList"
          :data="tempInputList"
          :row-class-name="setCurrentInputStyle"
          height="400">
          <el-table-column
            prop="default.title"
            label="名称">
          </el-table-column>
          <el-table-column
            label="控件类型">
            <template scope="scope">
              <span>{{ scope.row.default.type | inputTypeData }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="权限"
            width="325">
            <template scope="scope">
              <el-radio-group v-model="scope.row.auth" @change="authChange(scope.row)">
                <el-radio :label="INPUT_HIDDEN" :disabled="scope.row.disabled">不使用</el-radio>
                <el-radio :label="INPUT_EXIST" :disabled="isDisabled(scope.row)">不可见</el-radio>
                <el-radio :label="INPUT_READONLY" :disabled="scope.row.disabled">只读</el-radio>
                <el-radio :label="INPUT_EDITABLE" :disabled="isDisabled(scope.row)">可写</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="80">
            <template scope="scope">
              <el-button type="text" :disabled="scope.row.auth === INPUT_HIDDEN" @click="configRightInput(scope.row)">配置</el-button>
            </template>
          </el-table-column>
          <!--
          <el-table-column
            label="主字段">
            <template scope="scope">
              <el-select v-model="scope.row.key_major" placeholder="主字段" class="w-150 m-r-10" v-if="needDepentConfig(scope.row)">
                <el-option v-for="option in scope.row.key.show_name" :label="option" :value="option"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="从属字段">
            <template scope="scope">
              <el-button size="small" type="primary" @click="openDepentConfig(scope.row)" v-if="needDepentConfig(scope.row)">配置从属字段</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="默认传值">
            <template scope="scope">
              <div v-if="scope.row.auth == INPUT_EXIST">
                <el-select placeholder="请选择方式" v-model="scope.row.way" @change="changeWay(scope.row)">
                  <el-option
                    v-for="item in ways"
                    :key="item.value"
                    :label="item.way"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="从属字段">
              <template scope="scope">
                <el-button size="small" type="primary" @click="openDepentConfig(scope.row)" v-if="needDepentConfig(scope.row)">配置从属字段</el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="默认传值">
              <template scope="scope">
                <div v-if="scope.row.auth == INPUT_EXIST">
                  <el-select placeholder="请选择方式" v-model="scope.row.way" @change="changeWay(scope.row)">
                    <el-option
                      v-for="item in ways"
                      :key="item.value"
                      :label="item.way"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select placeholder="请选择" v-model="scope.row.field_default" v-if="scope.row.way == 20">
                    <el-option
                      v-for="item in userInfos"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-input v-model="scope.row.field_default" class="h-40 w-150" v-if="scope.row.way == 10"></el-input>
                </div>
              </template>
            </el-table-column> -->
        </el-table>
      </div>
      <!--右侧配置  -->
      <right-input-config 
        style="width:36%"
        :inputList="tempInputList"
        :userInfos="userInfos"
        :structList="structList"
        :currentInput="currentInput">
      </right-input-config>
      <!--右侧配置  -->
    </div>
    <div style="clear: both;"></div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="confirmNewInputList">确 定</el-button>
    </span>
  </el-dialog>
</template>

<style>
.red {
  background: #edf7ff!important;
}
</style>

<script>
  import flowConfig from '../../../../config/flowConfig'
  import modelConfig from '../../../../config/modelConfig'
  import http from '../../../../assets/js/http'
  import rightInputConfig from './rightInputConfig.vue'
  export default {
    props: {
      inputList: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        tempInputList: [],
        oldRule: 10,
        curRule: 10,
        ways: [
          {
            way: '常量',
            value: 10
          },
          {
            way: '登录用户的信息',
            value: 20
          }
        ],
        rules: [
          {
            name: '可写',
            id: 20
          },
          {
            name: '只读',
            id: 10
          },
          {
            name: '不使用',
            id: 30
          }
        ],
        wayValue: 10,
        currentInput: {},
        userInfos: [],
        structList: []
      }
    },
    methods: {
      replaceRule() { // 修改当前分组符合条件的控件权限
        _(this.tempInputList).forEach((res, index) => {
          if (!this.isDisabled(res) && res.auth == this.oldRule) {
            res.auth = this.curRule
          }
        })
      },
      needDepentConfig(item) {
        return item.default.type == this.TYPE_FOREIGNKEY && (item.auth == this.INPUT_EDITABLE || item.auth == this.INPUT_READONLY)
      },
      isDisabled(item) {
        return item.disabled || item.default.type == this.TYPE_DEALTIME
      },
      openDialog() {
        this.$refs.dialog.open()
      },
      closeDialog() {
        this.$refs.dialog.close()
      },
      authChange(item) {
        if (item.auth != this.INPUT_EXIST) {
          item.field_default = null
        }
      },
      setTempInputType(type) {
        _(this.tempInputList).forEach((res) => {
          if (!res.disabled) {
            if (!(res.default.type == this.TYPE_DEALTIME &&
                (type == this.INPUT_EDITABLE || type == this.INPUT_EXIST))) { // 获取系统时间类型只有不使用和只读
              res.auth = type
            }
          }
        })
      },
      openDepentConfig(item) {
        this.currentInput = item
        this.$emit('openDepentConfig')
        this.$emit('setKeyDepent', item.key_depent, item.key.show_name)
      },
      checkKeyMajorField() {  // 检查外键字段的主字段是否配置
        let pass = true
        _(this.tempInputList).forEach((res) => {
          if ((res.auth == this.INPUT_EDITABLE ||
              res.auth == this.INPUT_READONLY) &&
              res.default.type == this.TYPE_FOREIGNKEY &&
              !res.key_major) {
            pass = false
            return false
          }
        })
        return pass
      },
      confirmNewInputList() {
        // console.log(this.inputList)
        // if (!this.checkKeyMajorField()) {
        //   _g.toastMsg(this, 'warning', '请为外键配置主字段')
        //   return
        // }
        let sort = 0
        let newInputList = []
        _(this.tempInputList).forEach((res) => {
          // 删除没必要数据
          if (res.logic_condition && res.logic_condition.length > 0) {
            _(res.logic_condition).forEach((toRes) => {
              delete toRes.logicOptions2
            })
          }
          // 生成当前节点新的控件列表
          if (res.auth != this.INPUT_HIDDEN) {
            newInputList.push({
              field_id: res.default.field_id,
              title: res.default.title,
              name: res.default.name,
              type: res.default.type,
              sort: sort++,
              field_auth: res.auth,
              field_default: res.field_default,
              key_depent: res.key_depent,
              key_major: res.key_major,
              way: res.way,
              logic_condition: res.logic_condition,
              option_relation: res.option_relation,
              people_filter: res.people_filter,
              struct_filter: res.struct_filter,
              key_filter: res.key_filter,
              key_fillin: res.key_fillin,
              key_cascade: res.key_cascade // 外键级联
            })
          }
        })
        this.$emit('setNewInputList', newInputList)
        this.closeDialog()
      },
      confirmDepentConfig(keyDepent) {
        this.currentInput.key_depent = keyDepent
      },
      changeWay(row) {
        row.field_default = ''
      },
      configRightInput(item) {
        // console.log(item)
        // 设置当前列高亮
        this.currentInput = item
      },
      setCurrentInputStyle(row, index) {
        if (this.currentInput && this.currentInput.default && this.currentInput.default.name === row.default.name) {
          return 'red'
        }
        return ''
      }
    },
    created() {
      this.apiGet('cms/deals/fields/1').then((res) => {
        if (res.code == 200) {
          _(res.data).forEach((user) => {
            this.userInfos.push({
              name: user.title,
              value: user.field_id
            })
          })
        }
      })
      this.apiGet('cms/deals/fields/2').then((res) => {
        if (res.code == 200) {
          _(res.data).forEach((struct) => {
            this.structList.push({
              name: struct.title,
              value: struct.field_id
            })
          })
        }
      })
    },
    watch: {
      'inputList'() {
        this.currentInput = {}
        this.tempInputList = this.inputList
        // console.log('inputList', this.inputList)
      }
    },
    components: {
      rightInputConfig
    },
    mixins: [flowConfig, modelConfig, http]
  }
</script>




// WEBPACK FOOTER //
// inputList.vue?437e4793